module.exports = __webpack_public_path__ + "img/team-table.2e596c39.jpg";